import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { GlobalSearchService } from '../../services/global-search.service';
import { GlobalSearchResponse } from '../../models/response/global-search.response';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';

type GlobalSearchResult =
  | {
      label: string;
      value: {
        type: 'serviceValidation';
        id: number;
        customer?: string;
      };
    }
  | {
      label: string;
      value: {
        type: 'matchedSite';
        serviceValidationId: number;
        site: string;
        siteId: number;
        highlightTarget: string;
        source: string;
      };
    };

@Component({
  standalone: true,
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
  imports: [FormsModule, AutoCompleteModule, CommonModule, DialogModule],
})
export class GlobalSearchComponent {
  query = '';
  results: GlobalSearchResult[] = [];

  visible = false;
  isMac = navigator.platform.toLowerCase().includes('mac');
  constructor(
    private globalSearchService: GlobalSearchService,
    private router: Router
  ) {}

  @HostListener('document:keydown', ['$event'])
  handleShortcut(event: KeyboardEvent) {
    if ((this.isMac && event.metaKey) || (!this.isMac && event.ctrlKey)) {
      if (event.key.toLowerCase() === 'k') {
        event.preventDefault();
        this.visible = true;
      }
    }
  }

  onSearch(event: { query: string }) {
    const query = event.query.trim();

    if (query.length < 2) {
      this.results = [];
      return;
    }

    this.globalSearchService
      .search(query)
      .subscribe((res: GlobalSearchResponse) => {
        const suggestions: GlobalSearchResult[] = [];

        res.serviceValidations?.forEach((item) => {
          suggestions.push({
            label: `[ServiceValidation] ${item.customer}`,
            value: {
              type: 'serviceValidation',
              id: item.id,
              customer: item.customer,
            },
          });
        });

        res.matchedSites?.forEach((site) => {
          suggestions.push({
            label: `[Site] ${site.site} (Validation #${site.serviceValidationId})`,
            value: {
              type: 'matchedSite',
              site: site.site,
              siteId: site.siteId,
              highlightTarget: site.highlightTarget,
              source: site.source,
              serviceValidationId: site.serviceValidationId,
            },
          });
        });

        this.results = suggestions;
      });
  }

  navigateTo(event: { value: GlobalSearchResult }) {
    const result = event.value.value;

    if (result.type === 'serviceValidation') {
      this.router.navigate(['/serviceValidations'], {
        queryParams: {
          id: result.id,
        },
      });
    } else if (result.type === 'matchedSite') {
      this.router.navigate(['/serviceValidations', result.serviceValidationId]);

      this.router.navigate(
        ['/serviceValidations', result.serviceValidationId],
        {
          queryParams: {
            siteId: result.siteId,
          },
        }
      );
    } else {
      console.warn('Unsupported result type:', result);
    }
    this.visible = false;
    this.clear();
  }

  clear() {
    this.query = '';
    this.results = [];
  }

  getMatchParts(text: string) {
    const query = this.query.trim().toLowerCase();
    const lowerText = text.toLowerCase();
    const index = lowerText.indexOf(query);

    if (index === -1) {
      return { before: text, match: '', after: '' };
    }

    return {
      before: text.substring(0, index),
      match: text.substring(index, index + query.length),
      after: text.substring(index + query.length),
    };
  }
}
